import { RegisteredComponent } from "@builder.io/sdk-react";

export const swdcInternalSearchLeftFilterBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "SWDC Internal Search Left Filter",
  noWrap: true,
  hideFromInsertMenu: process.env.SITE !== "swdc",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: false,
  inputs: [
    {
      name: "showAllCategoriesText",
      type: "string",
      localized: true,
      defaultValue: "Show All Categories",
    },
  ],
};
